import React from 'react';
import styles from "./AllSetStep.module.scss";
import { AnchorLogo } from 'seagull/icons';
import { Typography } from 'seagull';
const NoPermissionsRelationshipApproved = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.reviewerRoot,
    "data-testid": "reviewer-all-set"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.reviewerInner
  }, /*#__PURE__*/React.createElement(AnchorLogo, {
    height: 44
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    weight: "normal"
  }, "This proposal has already been signed"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "If you would like to join this Anchor account, we recommend contacting the account owner.")));
};
export default NoPermissionsRelationshipApproved;